import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button'; // Assuming you have a Button component
import { Textarea } from '@/components/ui/textarea'; // Assuming you have a Textarea component
import { Label } from '@/components/ui/label'; // Assuming you have a Label component

interface LegalContentEditorProps {
  title: string;
  initialContent: string; // Initial content to load into the editor
  onSave: (content: string) => void; // Function to call when save button is clicked
}

const LegalContentEditor: React.FC<LegalContentEditorProps> = ({
  title,
  initialContent,
  onSave, // A função recebida como prop
}) => {
  const [content, setContent] = useState<string>(initialContent);

  // Log para verificar a função recebida na prop onSave
  useEffect(() => {
    console.log(`LOG: LegalContentEditor (${title}) - Função recebida em onSave:`, onSave);
  }, [onSave, title]); // Loga quando onSave ou title mudam

  // Update content if initialContent changes (e.g., when data is loaded)
  useEffect(() => {
    setContent(initialContent);
  }, [initialContent]);

  const handleSave = () => {
    console.log(`LOG: LegalContentEditor (${title}) - Botão Salvar clicado! Chamando onSave...`);
    try {
      // Verifica se onSave é realmente uma função antes de chamar
      if (typeof onSave === 'function') {
        onSave(content);
      } else {
        console.error(`LOG: LegalContentEditor (${title}) - ERRO: onSave não é uma função! Valor recebido:`, onSave);
      }
    } catch (error) {
        console.error(`LOG: LegalContentEditor (${title}) - ERRO ao executar onSave:`, error);
    }
  };

  return (
    <div className="space-y-4 border p-4 rounded-md mb-6">
      <h3 className="text-lg font-medium">{title}</h3>
      <div className="space-y-2">
        <Label htmlFor={`textarea-${title.replace(/\s+/g, '-')}`}>Conteúdo</Label>
        <Textarea
          id={`textarea-${title.replace(/\s+/g, '-')}`}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows={10} // Adjust rows as needed
          placeholder={`Digite o conteúdo para ${title}...`}
        />
      </div>
      <Button onClick={() => {
          console.log(`LOG: LegalContentEditor (${title}) - onClick direto do Botão disparado!`);
          handleSave();
      }}>Salvar {title}</Button>
    </div>
  );
};

export default LegalContentEditor;
